import { isNPO } from '@hellodarwin/core/lib/features/entities';
import React, { useEffect } from 'react';
import useOnboardingFlow from '../hooks/useOnboardingFlow';
import { OnboardingFlowProvider } from './OnboardingFlowProvider';
import OnboardingLayout from './common/OnboardingLayout';

const OnboardingFlow: React.FC = () => {
  const {
    currentStepContent,
    stepData: { formData },
    setStepData,
    validateCurrentStep,
    onboardingForm,
  } = useOnboardingFlow();

  useEffect(() => {
    onboardingForm?.setFieldsValue({
      ...formData,
    });
  }, [formData, onboardingForm]);

  if (!currentStepContent) return null;

  const handleFormChange = () => {
    const values = onboardingForm.getFieldsValue() as Record<string, string>;
    const updatedFormData = { ...formData, ...values };

    setStepData({ 
      formData: updatedFormData, 
      type: isNPO(updatedFormData.legal_structure ?? '') ? 'npo' : 'company' 
    });
    // Validate the form
    validateCurrentStep();
  };

  return <OnboardingLayout handleFormChange={handleFormChange} />;
};

const OnboardingFlowWithProvider: React.FC = () => {
  return (
    <OnboardingFlowProvider>
      <OnboardingFlow />
    </OnboardingFlowProvider>
  );
};

export default OnboardingFlowWithProvider;
